import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../data";

const About = () => {
  return (
    <section className="relative py-24 md:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="md:col-span-5"
        >
          <div className="overline mb-4">Living Aboard</div>
          <h2 className="font-display text-4xl md:text-5xl font-light leading-tight">
            Um arquipélago que poucos conhecem.
            <span className="block" style={{ color: "var(--ocean-accent)" }}>
              Você dorme dentro dele.
            </span>
          </h2>
          <div className="divider-grad my-8 max-w-[200px]" />
          <p className="text-base leading-relaxed" style={{ color: "var(--ocean-muted)" }}>
            O Parque Nacional Marinho de Abrolhos é o primeiro do Brasil — e ainda é um dos segredos
            mais bem guardados do Atlântico Sul. Saímos de Caravelas às 7h da manhã, dormimos
            ancorados entre as ilhas e voltamos transformados, com a pele salgada e a memória cheia.
          </p>
          <p className="mt-4 text-base leading-relaxed" style={{ color: "var(--ocean-muted)" }}>
            Não é um passeio de barco. É uma expedição. Tudo a bordo: café da manhã, almoço,
            lanche, jantar, frutas, sobremesas, roupa de cama e banho. Você só leva a vontade.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="md:col-span-7 grid grid-cols-6 grid-rows-6 gap-3 h-[520px]"
        >
          <div className="col-span-4 row-span-4 overflow-hidden relative noise-overlay">
            <img src={IMAGES.whaleSurface} alt="Baleia jubarte" className="w-full h-full object-cover" />
          </div>
          <div className="col-span-2 row-span-4 overflow-hidden">
            <img src={IMAGES.shipwreck} alt="Naufrágio" className="w-full h-full object-cover" />
          </div>
          <div className="col-span-3 row-span-2 overflow-hidden">
            <img src={IMAGES.sunset} alt="Ilha de Abrolhos" className="w-full h-full object-cover" />
          </div>
          <div className="col-span-3 row-span-2 overflow-hidden">
            <img src={IMAGES.catamaran} alt="Catamarã" className="w-full h-full object-cover" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
